<form novalidate (ngSubmit)="onSubmit()">
    <div id="vehicleDetailsContainer" class="container absolute top-20 right-0 hiddenDetails h-[calc(100vh-80px)] overflow-hidden flex flex-col openDetails">
        <section class="topbar h-14 mt-4 flex items-center pl-8">
            <h1 class="ml-2 text-xl font-semibold max-w-[50%] truncate">
                {{ literalService.get(newVehicle() ? 'vehicles.newVehicle' : 'vehicles.title', true) }}
            </h1>
            @if (!newVehicle()) {
                <div class="flex items-center justify-center ml-2 mr-2 h-6 w-6 cursor-pointer content-image">
                    <img [src]="images.vehicles.busCar"
                        alt="vehicleStatus" class="h-6 w-6"
                        (click)="editStatusClick()"
                        [tooltip]="literalService.get(vehicleStatus(), true)" [position]="TooltipPosition.BELOW"
                        [ngClass]="{'active': vehicleCopy.active, 'disabled': !vehicleCopy.active}" />
                </div>
                @if (editStatus) {
                    <app-select [elements]="statusList" [value]="vehicleStatus()" [id]="vehicleStatus()" [translateValue]="true" [autoOpen]="true" (changeEventEmitter)="changeStatus($any($event))" (onBlur)="changeStatus()" />
                }
            }
            <section id="actions" class="flex ml-auto mr-8 gap-2.5">
                @if (!newVehicle()) {
                    <div class="flex items-center justify-center content-image" (click)="editAction()">
                        <img [tooltip]="literalService.get('vehicles.tooltips.edit', true)" [position]="TooltipPosition.BELOW" [src]="images.vehicles.edit" alt="editVehicle" class="h-6 w-6 cursor-pointer" />
                    </div>
                }
                <div class="flex items-center justify-center content-image cursor-pointer h-6 w-6" (click)="close()">
                    <img [tooltip]="literalService.get('closeWindow', true)" [position]="TooltipPosition.BELOW" [src]="images.close" alt="closeDetails" class="h-6 w-6" />
                </div>
            </section>
        </section>
        <section class="h-full pt-8 px-8 pb-8 overflow-y-auto flex flex-col justify-between">
            <div class="flex flex-col gap-5">
                @for (element of vehicleForm(); track element.title) {
                    <article>
                        @if (edit) {
                            <app-input  [data]="element"
                                        [edit]="true"
                                        [independent]="false"
                                        [hasErrors]="invalid.includes(element.edit?.valueToChange)"
                                        [error]="showError(element.edit?.valueToChange)"
                                        (changeEventEmitter)="onInputChange($event, element)"
                                        (setEventEmitter)="onInputChange($event, element)" />
                        } @else {
                            <app-detail [data]="element" [value]="element.value" />
                        }
                    </article>
                }
                <div class="w-72 flex flex-col gap-2 bg-primary-purple-light-2 rounded-lg py-2.5 px-6">
                    <div class="flex justify-between items-center">
                        <span>
                            {{ literalService.get('vehicles.data.standardSeats', true) }}
                        </span>
                        <span class="flex items-center gap-1 font-bold">
                            {{ getTotalStandardSeats() }}
                            <img [src]="images.info" alt="totalStandardSeatsInfo" class="w-4 h-4 cursor-pointer" [tooltip]="literalService.get('vehicles.tooltips.seatsVariation', true)" [position]="TooltipPosition.BELOW_LEFT" />
                        </span>
                    </div>
                    <div class="flex justify-between gap-0.5 items-center">
                        <span>
                            {{ literalService.get('vehicles.data.prmSeats', true) }}
                        </span>
                        <span class="flex items-center gap-1 font-bold">
                            {{ getTotalPrmSeats() }}
                            <img [src]="images.info" alt="totalStandardSeatsInfo" class="w-4 h-4 cursor-pointer" [tooltip]="literalService.get('vehicles.tooltips.seatsVariation', true)" [position]="TooltipPosition.BELOW_LEFT" />
                        </span>
                    </div>
                </div>
            </div>
            @if (edit) {
                <div class="flex pt-8">
                    <app-form-actions [saveDisabled]="disabledButton()" (cancelAction)="cancel()" (saveAction)="onSubmit()" />
                </div>
            }
        </section>
    </div>
</form>
